export const CONSULTING = "CONSULTING";
export const FOLLOW_UP = "FOLLOW_UP";
export const NO_CHARGE = "NO_CHARGE";
export const HAS_APPOINTMENT = "HAS_APPOINTMENT";
export const ARRIVED = "ARRIVED";
export const IN_PROGRESS = "IN_PROGRESS";
export const WAITING_FOR_XRAY = "WAITING_FOR_XRAY";
export const IN_XRAY = "IN_XRAY";
export const DONE = "DONE";
export const PAID = "PAID";
export const DAY = "DAY";
export const EVENING = "EVENING";
export const ASIA_TZ = "Asia/Kolkata";
export const AMERICA_TZ = "America/Chicago";
export const PATIENT_MEDICAL_INFO = "/patient/medical-profile/";
export const PATIENT_PROFILE = "/patient/profile/";
export const APPOINTMENT = "/appointment/";
export const AFTERNOON_START_TIME = "";
